<template>
    <el-container>
        <el-header height="60px">
            <el-row >
                <el-col :span="4" class="align-left">P2P
                    <!--<el-dropdown>
                        <span class="el-dropdown-link">
                            P2P
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item 
                            v-for="item in colors"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            @click.native="onSetTheme(item.value)">{{item.label}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>-->
                </el-col>
                <el-col :span="15">
                    <nav-menu />
                </el-col>
                <el-col :span="5">
                    <el-dropdown>
                        <span class="el-dropdown-link">
                            <i class="el-icon-s-custom"></i>{{userInfo.username}}<a style="color: #cfcfcf;font-size: 12px;"> ( {{userInfo.role == 1?'超级管理员':'主账户'}} )</a><i class="el-icon-arrow-down el-icon--right"></i>
                            
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <!--<el-dropdown-item @click.native="personClickHandle">个人信息</el-dropdown-item>-->
                            <el-dropdown-item @click.native="passClickHandle">安全设置</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <span class="cursor-pointer" @click="loginOut"><i class="el-icon-switch-button"></i>退出</span>
                </el-col>
            </el-row>
            
        </el-header>
        <el-main>
            <router-view></router-view>
        </el-main>

        <el-dialog title="个人信息" :visible.sync="dialogPersonVisible" width="30%" :before-close="personBeforeClose">
            <el-form :model="personForm" :rules="personRules" ref="personForm" style="text-align: left;" label-width="120px">
                 <el-form-item label="账户名称" prop="user_account" class="item-list">
                    <el-input type="text" v-model="personForm.user_account" autocomplete="off" placeholder="请输入账号名称" disabled></el-input>
                </el-form-item>
                <el-form-item label="用户昵称" prop="username" class="item-list">
                    <el-input type="text" v-model="personForm.username" autocomplete="off" placeholder="请输入用户昵称"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button  @click="resetForm('personForm');dialogPersonVisible=false;">取 消</el-button>
                <el-button type="primary" @click="personSubmitForm('personForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改密码" :visible.sync="dialogPassVisible" width="30%" :before-close="passBeforeClose">
            <el-form :model="passwordForm" status-icon :rules="passRules" ref="passwordForm" style="text-align: left;" label-width="120px">
                 <el-form-item label="当前登录密码" prop="pass" class="item-list">
                    <el-input type="password" v-model="passwordForm.pass" autocomplete="off" placeholder="当前登录密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass" class="item-list">
                    <el-input type="password" v-model="passwordForm.checkPass" autocomplete="off" placeholder="确认密码"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="newPassword" class="item-list">
                    <el-input type="password" placeholder="请输入新密码" v-model="passwordForm.newPassword"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button  @click="resetForm('passwordForm');dialogPassVisible=false;">取 消</el-button>
                <el-button type="primary" @click="passSubmitForm('passwordForm')">确 定</el-button>
            </div>
        </el-dialog>


    </el-container>
</template>
<script>
    import crypto from 'crypto';
    import NavMenu from './components/NavMenu';
    
    export default {
        name: 'home',
        components: {
            NavMenu
        },
        data () {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                if (this.passwordForm.checkPass !== '') {
                    this.$refs.passwordForm.validateField('checkPass');
                }
                callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.passwordForm.pass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                colors: [{label: 'default',value: 'default'},{label: 'drak',value: 'drak'}],
                personForm: {
                    user_account: '',
                    username: '',
                    phone: localStorage.getItem('phone'),
                    e_mail: localStorage.getItem('e_mail'),
                },
                passwordForm: {
                    pass: '',
                    checkPass: '',
                    newPassword:''
                },
                personRules: {
                    user_account: [
                        { required: true, message: '请输入账号名称', trigger: 'blur' }
                    ],
                    username: [
                        { required: true, message: '请输入用户昵称', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: "请输入手机号", trigger: "blur" },
                        // 这个只能验证手机号
                        // { pattern:/^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: "请输入合法手机号", trigger: "blur" }
                        { pattern:/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" }
                    ],
                    e_mail: [
                        //{ required: true, message: "请输入邮箱", trigger: "blur" },
                        { pattern:/^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g, message: "请输入正确的邮箱", trigger: "blur"}
                    ],
                },
                passRules: {
                    pass: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    checkPass: [
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                    newPassword: [
                       { required: true, message: '请输入新密码', trigger: 'blur' }
                    ]
                },
                dialogPersonVisible:false, dialogPassVisible: false,
                id: localStorage.getItem('id'),
            }
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo
            }
        },
        mounted() {
            if(localStorage.getItem('userInfo')) {
                this.$store.commit('userInfo', JSON.parse(localStorage.getItem('userInfo')))
            }
        },
        methods: {
            onSetTheme(theme) {
                this.$parent.onSetTheme();
            },
            loginOut() {
				const this_ = this;
				this_.$confirm("是否确认退出登录?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						this_.$api.get(this_.GLOBAL.IP+'/user/logout')
                        .then(res=>{
                            if(res.code == 200) {
                                this_.$message.success(res.msg)
                            } else {
                                this_.$message.info(res.msg)
                            }
                            window.localStorage.clear();
                            //this_.$router.push({path:'/'})//退出之后重定向
                            if(this_.userInfo.role != 1) {
                                this_.$router.push({path:'/'})//退出之后重定向
                            } else {
                                this_.$router.push({path:'/login_admin'})
                            }
						}).catch(err=>{
							this_.$message.error('服务器连接失败')
						})
					})
					.catch(() => {});
			},
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        alert('submit!');
                    } else {
                        return false;
                    }
                });
            },
            passClickHandle() {
                this.dialogPassVisible = true;
                this.passwordForm.pass = '';
                this.passwordForm.checkPass = '';
                this.passwordForm.newPassword = '';
            },
            passSubmitForm(formName) {  //  修改密码
                const _self = this
                _self.$refs[formName].validate((valid) => {
                    if (valid) {
                        let formData = new FormData();
                        formData.append('password', _self.getmd5(_self.passwordForm.checkPass));
                        formData.append('newpassword',  _self.getmd5(_self.passwordForm.newPassword));
                        _self.$api.post(_self.GLOBAL.IP + "/user/updatePassword",{
                            id: _self.userInfo.id,
                            password:  _self.getmd5(_self.passwordForm.checkPass),
                            newpassword: _self.getmd5(_self.passwordForm.newPassword)
                        })
                        .then(res => {
                            if(res.code == 200) {
                                _self.$message.success(res.msg)
                                _self.dialogPassVisible = false;
                                _self.$router.push('/login');
                                localStorage.clear();
                                _self.resetForm('passwordForm');
                            } else {
                                _self.$message.info(res.msg)
                            };
                        }).catch(err => {
                            _self.$message.info('密码修改失败！')
                        })
                    } else {
                        return false;
                    }
                });
            },
            personClickHandle() {
                this.dialogPersonVisible = true;
                this.personForm.user_account = this.userInfo.account;
                this.personForm.username = this.userInfo.username;
            },
            personSubmitForm(formName) {    //  昵称修改
                const _self = this
                _self.$refs[formName].validate((valid) => {
                    if (valid) {
                        let formData = new FormData();
                        formData.append('username', _self.personForm.username)
                        formData.append('phone', _self.personForm.phone)
                        formData.append('e_mail', _self.personForm.e_mail)
                        _self.$api.put(_self.GLOBAL.IP + "/user/reset/"+_self.$store.state.userInfo.id+"/",formData)
                        .then(res => {
                            if(res.code == 200) {
                                _self.$message.success(res.msgs)
                                _self.dialogPersonVisible = false;
                                localStorage.setItem('userName', _self.personForm.username);
                                localStorage.setItem('phone', _self.personForm.phone);
                                localStorage.setItem('e_mail', _self.personForm.e_mail);
                                _self.username = _self.personForm.username;
                                _self.resetForm('personForm');
                            } else {
                                _self.$message.info(res.msgs)
                            };
                        }).catch(err => {
                            _self.$message.info('用户昵称修改失败！')
                        })
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            personBeforeClose() {
                this.dialogPersonVisible = false;
                this.$refs.personForm.resetFields();
            },
            passBeforeClose() {
                this.dialogPassVisible = false;
                this.$refs.passwordForm.resetFields();
            },
            getmd5(pwd){
                var md5 = crypto.createHash("md5");
                md5.update(pwd);
                var password = md5.digest('hex');
                return password;
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/assets/css/vars.scss';
    .el-container.is-vertical {
        width: 100%;
        height: 100%;
    }
    .el-header {
        height: 60px;
        line-height: 60px;
        color:#fff;
       // background: $main-Defaultcolor;
        @include color_primary($main-Defaultcolor)
    }
    .el-header i {
        margin-right: 4px;
    }
    .el-main {
        padding: 0 100px;
        /**height: calc(100% - 46px);***/
    }
    .align-left {
        font-size: 18px;
    }
    .item-list /deep/ .el-form-item__content, .item-list >>> .el-form-item__content {
        width: 200px;
    }
    .el-dropdown-link {color: #fff;margin-right:20px;font-size: 16px;}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue